/**
 * Link component using react-router-dom for client-side navigation.
 */

import * as Headless from "@headlessui/react";
import React, { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";

export const Link = forwardRef(function Link(
	props: { href: string } & Omit<React.ComponentPropsWithoutRef<typeof RouterLink>, "to">,
	ref: React.ForwardedRef<HTMLAnchorElement>,
) {
	const { href, ...rest } = props;

	// Check if it's an external link
	const isExternal =
		href.startsWith("http://") ||
		href.startsWith("https://") ||
		href.startsWith("mailto:") ||
		href.startsWith("tel:");

	if (isExternal) {
		return (
			<Headless.DataInteractive>
				<a {...rest} href={href} ref={ref} />
			</Headless.DataInteractive>
		);
	}

	return (
		<Headless.DataInteractive>
			<RouterLink {...rest} to={href} ref={ref} />
		</Headless.DataInteractive>
	);
});
